import { Component, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import AbstractView from '@/views/abstract-view';
import EventBus from '@vertical-plus/vue-js-core/dist/util/event/event-bus';
import Job from '@/model/entity/job/job';
import JobInformation from '@/components/job-information/index.vue';

@Component({
    components: {
        'app-job-information': JobInformation,
    },
})
export default class JobView extends AbstractView
{
    private job: Job|null = null;
    private options = false;

    protected get title(): string
    {
        return this.job?.name ?? this.defaultTitle;
    }

    protected created()
    {
        this.loadJob();
    }

    @Watch('$route')
    private onRouteChanged()
    {
        if (!this.job?.id || this.job.id !== parseInt(this.$route.params.id))
        {
            this.loadJob();
        }
    }

    /**
     * Loads the job
     */

    private async loadJob()
    {
        try
        {
            // Check for an action
            if (this.$route.query?.action)
            {
                // Get the action
                const action = this.$route.query?.action;

                // Process the action
                switch (action)
                {
                case 'accept':
                    this.job = await this.$serviceContainer.jobService.acceptJob(this.$route.params.id);
                    break;

                case 'review':
                    this.job = await this.$serviceContainer.jobService.reviewJob(this.$route.params.id);
                    break;

                default:
                    this.job = await this.$serviceContainer.jobService.loadJob(this.$route.params.id);
                }

                // Remove the action from the query
                const query = Object.assign({}, this.$route.query);
                delete query.action;
                this.$router.replace({ query });
            }
            else
            {
                this.job = await this.$serviceContainer.jobService.loadJob(this.$route.params.id);
            }
        }
        catch (error: unknown)
        {
            EventBus.instance.$emit(
                'notification',
                this.$t('general.error.failed_loading_server_error'),
                'error',
            );
        }
    }

    /**
     * Handles duplication request
     */

    private onDuplicate()
    {
        EventBus.instance.$emit(
            'confirm-dialog',
            this.$t('job.message.duplicate_confirmation_title'),
            this.$t('job.message.duplicate_confirmation_message'),
            () =>
            {
                this.duplicate();
            },
        );
    }

    /**
     * Duplicates the current job
     */

    private async duplicate()
    {
        if (!this.job)
        {
            return;
        }

        try
        {
            const job = new Job(cloneDeep(this.job.dto));
            job.id = null;
            job.name += ' copy';

            const duplicate = await this.$serviceContainer.jobService.createJob(job);

            this.$router.push({
                name: 'job-edit',
                params: {
                    id: `${ duplicate.id }`,
                },
            }).catch();

            EventBus.instance.$emit(
                'notification',
                this.$t('job.message.duplicated_successfully'),
                'success',
            );
        }
        catch (error: unknown)
        {
            EventBus.instance.$emit(
                'notification',
                this.$t('job.error.failed_duplicating_job'),
                'error',
            );
        }
    }
}